import { NgModule, Pipe } from '@angular/core';
import { PermissionPipe } from './permission.pipe';
import { CommonModule } from '@angular/common';
import { YesnoPipe } from './yesno.pipe';
import { ObjectLinkPipe } from './object-link.pipe';

@NgModule({
  declarations: [PermissionPipe, YesnoPipe, ObjectLinkPipe],
  imports: [CommonModule],
  providers: [],
  exports: [PermissionPipe, YesnoPipe, ObjectLinkPipe],
})
export class PipesModule {}
